import React from 'react';
import './Appointments.scss';
import Avatar from 'src/components/base/Avatar/Avatar';
import AppointmentDetails from './AppointmentDetails';
import { Appointment } from '../Calendar/calendarTypes';
import { ConvertToLocalTime, hasDateTimePassed } from '../../utils';
import { Typography } from "src/latest/src/components";

interface Props {
  title?: string;
  appointmentsData: Appointment[];
  onDelete:  (appointmentId: number)=> void;
  selectedUserType: string[];
  activeToolTipId?: string;
  setActiveToolTip: (id: string) => void;
}

const AppointmentList: React.FC<Props> = ({
  title,
  appointmentsData,
  onDelete,
  selectedUserType,
  activeToolTipId,
  setActiveToolTip,
}) => {
  const renderAppointment = (appointment: Appointment) => {
    const isAppointmentTimePassed = hasDateTimePassed(appointment.slot_start_date_time, appointment.duration);

    return (
      <tr className={`appointments_list_Container ${isAppointmentTimePassed ? 'disabled' : ''}`} key={appointment?.id}>
        <td className="client-avatar-container">
          <Avatar
            photoUrl={
              selectedUserType?.includes('THERAPIST')
                ? appointment?.client_profile_pic
                : appointment?.therapist_profile_pic
            }
            fullName={
              selectedUserType?.includes('THERAPIST')
                ? appointment?.client_name
                : appointment?.therapist_name
            }
            className="client-avatar-img"
            size="40px"
          />
        </td>
        <td
          className={`color-2 client-name fw-semibold ${
            !appointment?.client_name || !appointment?.therapist_name
              ? 'text-center'
              : ''
          }`}
        >
          {selectedUserType?.includes('THERAPIST')
            ? appointment?.client_name || '--'
            : appointment?.therapist_name || '--'}
        </td>
        <td className="color-2 appointment-time fw-semibold ">
          {ConvertToLocalTime(appointment?.slot_start_date_time)}
        </td>
        <td className="color-2 appointment-duration">
          {appointment?.duration} mins
        </td>
        <td className="color-2 client-meeting-pref fw-semibold ">
          {appointment?.meeting_pref}
        </td>
        <td className="color-2 client-service-type">
          {appointment?.service_types}
        </td>
        <td className="details-container">
          <div>
            <AppointmentDetails
              clientName={appointment?.client_name}
              therapistName={appointment?.therapist_name}
              officeLocation={appointment?.office_location}
              recurrent={appointment?.recurrent}
              onDelete={onDelete}
              eventId={appointment?.id}
              eventType={appointment?.slot_type}
              startDateTime={appointment?.slot_start_date_time}
              duration={appointment?.duration}
              activeTooltipId={activeToolTipId}
              onToggleTooltip={setActiveToolTip}
              appointment={appointment}
            />
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="container">
      {title && (
        <div className="row">
          <div className="col-12 p-0 mb-3">
            <Typography variant="size-16" color="color-2" weight="semi-bold">
              {title}
            </Typography>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12 p-0">
          <div className="table-responsive appointments_data ">
            <table className="custom-table">
              <tbody>
                {appointmentsData?.map(appointment => (
                  <>{renderAppointment(appointment)}</>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentList;
